import React, {Suspense} from 'react'
import { Route } from 'react-router-dom'
import PageTitleComponent from "../components/page-title.component";
import PreloaderContainer from '@components/layout/preloader/preloader.component'
import { fb } from '~/utils/marketing/fb';
import {getLazyComponent} from '~/router/mapping';

export const PublicRoute = ({
    ...rest
}) => {
    const LazyComponent = getLazyComponent(rest.path);
    return (
        <Route {...rest} component={(props) => (
            <>
                {fb.init()}
                <PageTitleComponent path={rest.path}/>
                <Suspense fallback={'...'}>
                    <LazyComponent {...props} />
                </Suspense>
                <PreloaderContainer/>
            </>
        )}/>
    );
}
